import http from '../http'
import {
	IFeatureAccessDto,
	IJurisdictionDto,
	IJurisdictionPropertiesDto,
	IOnboardingDto,
	ISetWealthicaPlanParams,
	ITutotialStatusDto,
	IUserDto,
} from './dtos'
import {
	mapFeatureAccessFromDto,
	mapJurisdictionFromDto,
	mapJurisdictionPropertiesFromDto,
	mapTutorialStatusFromDto,
	mapUserFromDto,
} from './helpers'
import { IUser, IWealthicaCredentials } from './models'

const rootAPI = http.createClient(`${process.env.NEXT_PUBLIC_API_URL}`)
const usersAPI = http.createClient(`${process.env.NEXT_PUBLIC_API_URL}/users`)

export const getCurrentUser = async () => {
	const { data } = await usersAPI.get<IUserDto>('/me')
	return mapUserFromDto(data)
}

export const getUserById = async (userId: IUserDto['userId']) => {
	const { data } = await usersAPI.get<IUserDto>(`/${userId}`)
	return mapUserFromDto(data)
}

export const updateUser = async (params: Partial<IUserDto> & { id: IUserDto['userId'] }) => {
	await usersAPI.put(`/${params.id}`, {
		...params,
		id: undefined,
	})
	return
}

export const setReferral = async (referral: string) => {
	const { data } = await rootAPI.post('/partners/referrals', { referral })
	return data
}

export const getFeatureAccess = async () => {
	const { data } = await rootAPI.get<IFeatureAccessDto>('/access')
	return mapFeatureAccessFromDto(data)
}

export const getSupportedJurisdictions = async () => {
	const { data } = await rootAPI.get<IJurisdictionDto[]>('/jurisdictions')
	return data.map(mapJurisdictionFromDto)
}

export const getJurisdictionBySlug = async (slug: string) => {
	const { data } = await rootAPI.get<IJurisdictionDto>(`/jurisdictions/${slug}`)
	return mapJurisdictionFromDto(data)
}

export const getJurisdictionProperties = async (slug: string) => {
	const { data } = await rootAPI.get<IJurisdictionPropertiesDto>(`/jurisdictions/${slug}/properties`)
	return mapJurisdictionPropertiesFromDto(data)
}

export const getOnboardingStatus = async () => {
	const { data } = await rootAPI.get<{ finished: boolean }>('/onboarding')
	return data
}

export const changeOnboardingStatus = async (params: IOnboardingDto) => {
	const { data } = await rootAPI.post('/onboarding', params)
	return data
}

export const getTutorialStatus = async () => {
	const { data } = await rootAPI.get<ITutotialStatusDto>('/tutorials')
	return mapTutorialStatusFromDto(data)
}

export const changeTutorialStatus = async (params: Partial<ITutotialStatusDto>) => {
	const { data } = await rootAPI.put('/tutorials', params)
	return data
}

export const syncUserPlan = async (params: ISetWealthicaPlanParams) => {
	await usersAPI.put('/me/set-wealthica-layer', params)
}

export const connectWealthicaUser = async (wealthicaUserId: string) => {
	await usersAPI.put('/me/assign-wealthica-user', {
		wealthicaUserId,
	})
}

// axios is protected by aws sdk, need to use pure fetch
export const getWealthicaCredentials = async (email: IUser['email']) => {
	const { data } = await usersAPI.post<IWealthicaCredentials>('/wealthica', { email })
	return data
}
